import React from 'react';
import classes from "./AutoRenewalModal.module.css";
import { useTranslation } from 'react-i18next';
import { FaXmark } from "react-icons/fa6";

const AutoRenewalModal = ({setModal}) => {
    const {t}=useTranslation();
    return (
        <div className={classes.container} onClick={() => setModal(false)}>
            <div className={classes.sub_container} onClick={(e) => e.stopPropagation()}>
                <button type="button" className={classes.close_btn} onClick={()=>setModal(false)}>
                    <FaXmark className={classes.close_icon} />
                </button>
                <div className={classes.msg}>
                    <p className={classes.text}>
                         By selecting Autorenewal, you confirm that you will be auto renewed daily at 50 CFA. You can deactivate the service anytime in profile page using unsubscribe button .Play more quiz and accumulate points, Top 5 users with maximum points will be awarded with data bundles at the end of the month.
                    </p>
                </div>
            </div>
        </div>
    )
}

export default AutoRenewalModal;